import moment from 'moment'
import FormStore from '../../../utils/stores/FormStore'

const initState = {
  surname: '',
  name: '',
  patronymic: '',
  phone: '',
  territory: '',
  district: '',
  locality: '',
  addressType: '',
  address: '',
  house: '',
  building: '',
  apartment: '',
  preferentialCategory: '',
  created: '',
  additionalInfo: '',
  senderId: '',
  equipmentId: '',
  reason: '',
  reasonId: '',
  financialSourceId: '',
  categories: [],
  hasDuplicates: false,
}

const validateDataTemplate = {
  surname: { required: true },
  name: { required: true },
  territory: { required: true },
  district: { required: true },
  address: { required: true },
  locality: { required: true },
  financialSourceId: { required: true },
  phone: { required: true },

  created: {
    required: true,
    validators: [
      (value) => value.length < 16,
      (value) => {
        return (
          !moment(value, 'DD-MM-YYYY, HH:mm').isValid() ||
          moment(value, 'DD-MM-YYYY, HH:mm').isAfter(moment())
        )
      },
    ],
  },
  senderId: { required: true },
}

class AddRequestFormStore extends FormStore {
  constructor() {
    const validateData = { ...validateDataTemplate }

    super({ initState, validateData })
    this.showErrors = true
    this.isValid = false
  }

  setFinancialSourceId = (financialSourceId) =>
    (this.data.financialSourceId = +financialSourceId)
}

export default AddRequestFormStore
